import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';

@Component({
    components: AllComponents(),
})
export default class Qa extends Mixins(CommonView) {
    changeAddress: boolean = false;

    public created() {
        this.init();
    }

    @Watch('$route')
    public init() {
        if(this.$route.hash == "#changeAddress"){
            this.changeAddress = true;
        }

    }
}
